import { FormControls } from '@elementary/common-ui/components';
import { UseFormWatch } from 'react-hook-form';
import SeverityRenderer from 'shared/components/SeverityRenderer';
import { AddTestForm } from 'shared/types';

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const CustomQueryConfig = ({ watch }: Props) => (
  <>
    <FormControls.FormText>
      Test name: <b>{watch('testName')}</b>
    </FormControls.FormText>

    <SeverityRenderer severity={watch('severity')?.type || 'error'} />
  </>
);

export default CustomQueryConfig;
